import { z } from 'zod';

export const ReportInputSchema = z.object({
    from: z.optional(z.date({ coerce: true })),
    to: z.optional(z.date({ coerce: true })),
    interval: z.optional(z.enum(['day', 'week', 'month', 'quarter', 'year'])),
    amount: z.optional(z.coerce.number({ coerce: true })),
});
